import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  User,
  Company,
  Project,
  License,
  CreateLicenseData,
  EditLicenseData,
} from "../../store/types";
import LicenseDialogs from "../Dialogs/LicenseDialogs";
import { Button } from "primereact/button";
import { IconPlus } from "../../assets/icons/Icon";
import { Label } from "../../styles/PageLayoutStyles.styles";

interface AddLicenseProps {
  user?: User;
  company?: Company;
  project?: Project;
  usersOptions?: { label: string; value: any }[];
  companiesOptions?: { label: string; value: any }[];
  projectsOptions?: { label: string; value: any }[];
  handleActivateLicense: (id: string) => Promise<boolean>;
  handleDeactivateLicense: (id: string) => Promise<boolean>;
  handleAddLicense: (
    license: CreateLicenseData
  ) => Promise<{ success: boolean; licenseIds?: string[] }>;
  handleEditLicense: (license: EditLicenseData, id: string) => Promise<boolean>;
  handleAssignSeat: (licenseId: string, userId: string) => Promise<boolean>;
  handleDeleteLicense: (license: License) => Promise<boolean>;
  refetchData: () => {};
  licensesEP: string;
  isMobile?: boolean;
}

const AddLicenseDialogButton: React.FC<AddLicenseProps> = ({
  user,
  company,
  project,
  usersOptions,
  companiesOptions,
  projectsOptions,
  handleActivateLicense,
  handleDeactivateLicense,
  handleAddLicense,
  handleEditLicense,
  handleAssignSeat,
  handleDeleteLicense,
  refetchData,
  licensesEP,
  isMobile = false,
}) => {
  const navigate = useNavigate();
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);

  const handleCreate = () => {
    if (isMobile) {
      if (company)
        navigate(`/companies/${company.id}/licenses/form?mode=create`);
      if (user) navigate(`/users/${user.id}/licenses/form?mode=create`);
      if (project)
        navigate(`/projects/${project.id}/licenses/form?mode=create`);
    } else {
      setDialogVisible(true);
    }
  };

  const handleDialogHide = () => {
    setDialogVisible(false);
  };

  return (
    <>
      <Button onClick={handleCreate}>
        <IconPlus size={16} />
        <Label>Новая лицензия</Label>
      </Button>
      {dialogVisible && (
        <LicenseDialogs
          visible={dialogVisible}
          onHide={handleDialogHide}
          dialogType={"create"}
          user={user}
          company={company}
          project={project}
          handleActivateLicense={handleActivateLicense}
          handleDeactivateLicense={handleDeactivateLicense}
          handleAddLicense={handleAddLicense}
          handleEditLicense={handleEditLicense}
          handleAssignSeat={handleAssignSeat}
          handleDeleteLicense={handleDeleteLicense}
          refetchData={refetchData}
          usersOptions={usersOptions}
          companiesOptions={companiesOptions}
          projectsOptions={projectsOptions}
          licensesEP={licensesEP}
        />
      )}
    </>
  );
};

export default AddLicenseDialogButton;
